module.exports = __webpack_public_path__ + "static/img/d13128a6e5cf8ea3c914493299594f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usb_white.png
// module id = +mR2
// module chunks = 1